import { observable, action, computed, toJS } from 'mobx'

export enum ExportType {
    QAll,
    QDraft,
    QScored,
    QInProgressCreditConsultant,
    QInProgressCreditExpert,
    QFind,
    Payments,
    TroubleEventsList,
    TroubleEventsListNew,
    TroubleEventsListInProgress,
    Merchants,
    Affiliates,
    CatalogProducts,
    Users,
    Settings
}

export interface IExportStoreEntity {
    [key: string]: object | string,
    list: Array<Object>
}

export default class ExportStore {

    public static getInstance(): ExportStore {
        return this._instance || (this._instance = new this())
    }

    private static _instance: ExportStore

    @observable.shallow
    private items: Array<IExportStoreEntity> = []

    @action.bound
    setItems(type: ExportType, items: Array<any>) {
        if (!items || !items.length) {
            return
        }

        let localData = toJS(this.items)

        localData[type.toString()] = items
        this.items = localData
    }

    @computed
    public get getItems(): Array<IExportStoreEntity> {
        return this.items
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/ExportStore.ts